export default __webpack_public_path__ + "static/media/boarding.6e278a39.png";